export default {
	title: 'Cultus gGmbH der Landeshauptstadt Dresden',
	gsmaterials: {
		app: {
			scrollTop: {
				offset: 250,
				size: 'lg',
				icon: 'i-mdi-chevron-up',
				class: 'z-20 bg-silver-chalice-400 hover:bg-primary hover:[&_.iconify]:text-white transition-colors duration-300 ease-in-out'
			},
		},
		apiData: {
			menus: {
				url: '/rest/menus',
				query: () => {return { is_active: true, sort: '-valid_from'}},
				frozen: ['is_active'],
				watch: false,
				preload: false
			},
			groupedMenus: {
				url: '/rest/grouped-menus',
				watch: false,
				preload: false
			},
			locationMenus: {
				url: '/rest/menus',
					query: () => {return { is_active: true, sort: 'valid_from'}},
				frozen: ['is_active'],
				watch: true,
				preload: false
			},
		},
	},
	ui: {
		button: {
			base: 'cursor-pointer transition duration-300 ease-in-out',
			defaultVariants: {
				size: 'xl',
				color: 'neutral',
				variant: 'outline'
			},
			compoundVariants: [
				{
					color: 'neutral',
					variant: 'outline',
					class: 'inline-flex justify-center px-6 lg:px-8 py-3.5 [&_.iconify]:mr-2 [&_span]:font-medium [&_span]:leading-tight [&_span]:text-[1rem] md:[&_span]:text-[1.15rem] xl:[&_span]:text-[1.25rem] text-woodsmoke-950 ring-1 ring-woodsmoke-950 hover:ring-yellow-sea-500 bg-white hover:bg-yellow-sea-500 rounded-full'
				},
				{
					color: 'neutral',
					variant: 'link',
					class: '[&_span]:size-8 hover:bg-transparent! [&_span]:text-woodsmoke-950 hover:[&_span]:text-yellow-sea-500'
				},
			]
		},
		checkbox: {
			slots: {
				base: 'cursor-pointer',
				label: 'font-light text-[1rem] md:text-[1.25rem] [&_a]:text-[1rem] md:[&_a]:text-[1.25rem] [&_a]:underline -mt-0.5 cursor-pointer after:hidden',
				container: 'flex items-start items-center'
			},
			defaultVariants: {
				size: 'xl',
				color: 'primary',
				variant: 'list',
				indicator: 'start'
			}
		},
		pagination: {
			slots: {
				base: 'flex items-center justify-center',
				list: 'gap-2',
				item: 'aspect-square! px-4! rounded-full border-0 h-11.5 shadow-none hover:bg-accent hover:[&_span]:text-white ring-gray-300 ring-1 hover:ring-accent data-[selected=true]:bg-primary data-[selected=true]:ring-accent',
				prev: 'border-0 h-11.5 shadow-none [&_.iconify]:mr-0 disabled:[&_.iconify]:text-gray-300 hover:bg-primary hover:[&_span]:text-white ring-gray-300 ring-1 hover:ring-primary disabled:hover:ring-gray-300',
				next: 'border-0 h-11.5 shadow-none [&_.iconify]:mr-0 disabled:[&_.iconify]:text-gray-300 hover:bg-primary hover:[&_span]:text-white ring-gray-300 ring-1 hover:ring-primary disabled:hover:ring-gray-300',
				first: 'border-0 h-11.5 shadow-none [&_.iconify]:mr-0 disabled:[&_.iconify]:text-gray-300 hover:bg-primary hover:[&_span]:text-white ring-gray-300 ring-1 hover:ring-primary disabled:hover:ring-gray-300',
				last: 'border-0 h-11.5 shadow-none [&_.iconify]:mr-0 disabled:[&_.iconify]:text-gray-300 hover:bg-primary hover:[&_span]:text-white ring-gray-300 ring-1 hover:ring-primary disabled:hover:ring-gray-300',
				label: 'text-center font-medium text-[1.2rem]! min-w-auto'
			}
		},
	}
}
